import { Instagram, Facebook, Phone, Mail, MapPin } from "lucide-react";
import { LOGO, NAV, PHONE_DISPLAY, EMAIL, CITY, INSTAGRAM_URL, FACEBOOK_URL, WHATSAPP_URL } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="bg-ink text-offwhite" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-12 py-16 grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <div className="mb-5">
            <div className="inline-block bg-offwhite rounded-2xl p-3">
              <img src={LOGO} alt="C Duarte Home Pro — Handyman & Cleaning" className="h-16 w-auto object-contain" />
            </div>
          </div>
          <p className="text-offwhite/60 font-light max-w-sm leading-relaxed">
            From repairs to clean — we've got your home covered. A trusted, family-run home services company in Charlotte, NC.
          </p>
          <div className="flex gap-3 mt-6">
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="h-10 w-10 rounded-lg bg-offwhite/10 flex items-center justify-center hover:bg-mustard hover:text-ink transition-colors duration-300"><Instagram className="h-5 w-5" /></a>
            <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="h-10 w-10 rounded-lg bg-offwhite/10 flex items-center justify-center hover:bg-mustard hover:text-ink transition-colors duration-300"><Facebook className="h-5 w-5" /></a>
          </div>
        </div>

        <div>
          <h4 className="font-display font-bold text-sm tracking-[0.15em] uppercase text-offwhite/50 mb-5">Quick Links</h4>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.href}>
                <a href={n.href} className="text-offwhite/75 hover:text-mustard font-light transition-colors duration-300" data-testid={`footer-link-${n.label.toLowerCase().replace(/\s/g, "-")}`}>{n.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-sm tracking-[0.15em] uppercase text-offwhite/50 mb-5">Contact</h4>
          <ul className="space-y-4 text-offwhite/75 font-light">
            <li className="flex items-center gap-3"><Phone className="h-4 w-4 text-mustard" /><a href={`tel:+${PHONE_DISPLAY.replace(/\D/g, "")}`} className="hover:text-mustard transition-colors">{PHONE_DISPLAY}</a></li>
            <li className="flex items-center gap-3"><Mail className="h-4 w-4 text-mustard" /><a href={`mailto:${EMAIL}`} className="hover:text-mustard transition-colors" data-testid="footer-email">{EMAIL}</a></li>
            <li className="flex items-center gap-3"><MapPin className="h-4 w-4 text-mustard" />{CITY} & surrounding</li>
          </ul>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex mt-6 rounded-full bg-mustard px-6 py-2.5 text-sm font-semibold text-ink hover:scale-[1.04] transition-transform duration-300" data-testid="footer-quote-btn">Get a Free Quote</a>
        </div>
      </div>

      <div className="border-t border-offwhite/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-offwhite/50">
          <p>© {new Date().getFullYear()} C Duarte Home Pro. All rights reserved.</p>
          <p className="font-light">Handyman & Cleaning Services · Charlotte, NC</p>
        </div>
      </div>
    </footer>
  );
}
